/**
 * ImportActionWindow — what an `import` action button opens, bound to the
 * platform (`/api/record-import` + the platform grid runtime). The window is
 * shared with the downloaded runtime and J2EE — see
 * `@twasta/page-runtime/txn/capture`.
 */
import { ImportActionWindow as SharedImportActionWindow } from '@twasta/page-runtime/txn/capture'
import type { ImportActionRequest } from '@twasta/page-runtime/txn'
import { platformRecordImportTransport } from '@/api/recordImport'
import { usePlatformImportRuntime } from './importRuntime'

export function ImportActionWindow({ project, req, onClose }: {
  project: string
  req: ImportActionRequest
  onClose: () => void
}) {
  const captureRuntime = usePlatformImportRuntime(project)
  return (
    <SharedImportActionWindow
      project={project}
      req={req}
      onClose={onClose}
      transport={platformRecordImportTransport}
      captureRuntime={captureRuntime}
    />
  )
}
